
import {SegmentMediaRef, SegmentTimeMap} from './types'

type MapType = (videoElements: HTMLMediaElement[]) => Promise<SegmentTimeMap>[]


const mappingFN = async (mediaElement: HTMLMediaElement) =>
  new Promise<SegmentTimeMap>((innerResolve) => {
    const {duration} = mediaElement
    const onTimeUpdate = (time: any) => {
      mediaElement.pause()
      mediaElement.removeEventListener('timeupdate', onTimeUpdate)
      innerResolve({
        encodingStartTime: mediaElement.currentTime,
        startTime: 0,
        duration
      })
    }
    mediaElement.addEventListener('timeupdate', onTimeUpdate)
    mediaElement.play()
  })

export const getActualStartingTimes = (refs: SegmentMediaRef[]): Promise<SegmentTimeMap[]> =>
  new Promise(async (resolve) => {

    const videoElements = refs.reduce((acc: HTMLVideoElement[], segment) => {
      if (segment.video.current != null) {acc.push(segment.video.current)}
      return acc
    }, [])
    const audioElements = refs.reduce((acc: HTMLAudioElement[], segment) => {
      if (segment.audio.current != null) {acc.push(segment.audio.current)}
      return acc
    }, [])

    const results = await Promise.all(videoElements.map(mappingFN))

    results.forEach((segment, index) => {
      if (index > 0) {
        segment.startTime = results[index - 1].startTime + results[index - 1].duration
      }
    })

    // RESET AUDIO
    audioElements.forEach((el) => el.currentTime = 0)

    resolve(results)
  })